import { createReducer } from "redux-create-reducer";

import {
  GET_LAST_SCORING_LOGS,
  SET_CURRENT_PAGE_SCORING_LOGS,
  SET_ITEMS_PER_PAGE_SCORING_LOGS,
} from "../types/getLastScoringLogsTypes";

const initialState = {
  data: [],
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 0,
  },
  isLoading: false,
};

const getLastScoringLogsReducer = createReducer(initialState, {
  [GET_LAST_SCORING_LOGS.PENDING]: (state, { payload }) => ({
    ...state,
    isLoading: true,
  }),
  [GET_LAST_SCORING_LOGS.REJECTED]: (state, { payload }) => ({
    ...state,
    isLoading: false,
  }),
  [GET_LAST_SCORING_LOGS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
  }),
  [SET_CURRENT_PAGE_SCORING_LOGS]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [SET_ITEMS_PER_PAGE_SCORING_LOGS]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
});

export default getLastScoringLogsReducer;



// WEBPACK FOOTER //
// ./src/features/score-card/reducers/getLastScoringLogsReducer.js